import {AbstractControl, type ValidationErrors} from '@angular/forms';
import {type OrganizationResponse} from '@middleware';

let orgs: OrganizationResponse[] = null;
let confusibles: {[orgDomain: string]: string[]} = null;

// this should come from some configuration somewhere, but I don't know where...
export const defaultConfusibles = {
  'virginia.edu': ['virgina.edu', 'uvahealth.org', 'mc.virginia.edu', 'hscmail.mcc.virginia.edu'],
  'vt.edu': ['vtc.vt.edu'],
};

function toEmailList(value: string | string[] | null | undefined): string[] {
  if (Array.isArray(value)) return value.map(v => String(v).trim()).filter(e => e.length > 0);

  const str = String(value ?? '').trim();
  if (!str) return [];

  return str.split(/[,; ]+/).filter(e => e.length > 0);
}

export function OrganizationalEmailValidator(control: AbstractControl): ValidationErrors {
  if (orgs == null) return null;
  const errors = [];
  const emails = toEmailList(control.value);
  if (emails.length === 0) return null;

  for (let email of emails) {
    if (!email.includes('@')) {
      errors.push(email);
      continue;
    }

    let domain = email.split('@', 2)[1];
    if (!orgs.some(org => (org.email_domains as string[]).includes(domain))) {
      errors.push(email);
    }
  }
  if (errors.length > 0) {
    return {'org-email': errors};
  }
  return null;
}

export function OrganizationalEmailValidatorMessage(errors: string[]): string {
  confusibles ??= defaultConfusibles;
  const messages = errors.map(email => {
    const [localPart, badDomain] = email.split('@', 2);
    if (badDomain != undefined) {
      for (let goodDomain in confusibles) {
        if (confusibles[goodDomain].includes(badDomain)) {
          return `"${email}" isn't recognized as belonging to any known organization. Did you mean "${localPart}@${goodDomain}"?`;
        }
      }
    }
    return `"${email}" isn't recognized as belonging to any known organization.`;
  });
  return messages.join(' ');
}

export function SetOrganizations(newOrgs: OrganizationResponse[]) {
  orgs = newOrgs;
}

export function SetConfusibles(newConfusibles: {[orgDomain: string]: string[]}) {
  confusibles = newConfusibles;
}
